<template>
  <div class="container mt-4">
    <div class="card p-4 shadow-lg border-0 bank-card">

      <!-- TITLE -->
      <div class="d-flex align-items-center mb-4">
        <i class="fas fa-university me-2 title-icon"></i>
        <h4 class="m-0 fw-bold title-text">
          {{ t("bankuser.title") }}
        </h4>
      </div>

      <!-- LOADING -->
      <div v-if="loading" class="text-center my-4">
        <div class="spinner-border" style="color: #b03a45;"></div>
        <div class="mt-2 text-muted">
          {{ t("bankuser.loading") }}
        </div>
      </div>

      <!-- NO DATA -->
      <div v-else-if="!details" class="text-center text-muted my-4">
        {{ t("bankuser.noData") }}
      </div>

      <!-- DETAILS -->
      <div v-else class="details-box">
        <div class="detail-item">
          <span class="label">{{ t("bankuser.rib") }}:</span>
          <span class="value">{{ details.rib }}</span>
        </div>

        <div class="detail-item">
          <span class="label">{{ t("bankuser.paymentMethod") }}:</span>
          <span class="value">{{ details.payment_method }}</span>
        </div>

        <div class="detail-item">
          <span class="label">{{ t("bankuser.bankName") }}:</span>
          <span class="value">{{ details.bank?.name }}</span>
        </div>

        <div class="detail-item">
          <span class="label">{{ t("bankuser.bankCode") }}:</span>
          <span class="value">{{ details.bank?.code }}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import axios from "@/api";

const { t } = useI18n();

const details = ref(null);
const loading = ref(true);

onMounted(async () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    const response = await axios.get(`/employee/bank-details/${user.id}`);
    details.value = response.data.data;
  } catch (err) {
    console.error("ERROR =", err);
    details.value = null;
  } finally {
    loading.value = false;
  }
});
</script>

<style scoped>
.bank-card {
  border-radius: 16px;
  background: #ffffff;
}

.title-icon {
  font-size: 24px;
  color: #b03a45;
}

.title-text {
  color: #b03a45;
}

.details-box {
  margin-top: 20px;
}

.detail-item {
  margin-bottom: 12px;
}

.label {
  font-weight: 600;
  color: #b03a45;
  font-size: 15px;
}

.value {
  font-size: 15px;
  margin-left: 5px;
  color: #333;
}
</style>
